import React from "react";
import {
  Body1Strong,
  Link,
  Popover,
  PopoverSurface,
  PopoverTrigger,
} from "@fluentui/react-components";
import { useStyles } from "./privacyLinkStyles";
import { appInsights, trackEvent } from "../../../common/appInsights";
import { appInsightsEvents, useAppStore } from "../../../common";

function PrivacyLink() {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);

  const onClick = () => {
    trackEvent(appInsights, appInsightsEvents.Usage.Actions.NavigateToPrivacyStatement, context);
    window.open("https://privacy.microsoft.com/en-US/data-privacy-notice", "_blank", "noreferrer");
  };

  return (
    <Popover openOnHover size="small" positioning={"above-end"}>
      <PopoverTrigger disableButtonEnhancement>
        <Body1Strong
          className={styles.button}
          onClick={onClick}
          data-testid="privacyLink"
          role="link"
        >
          Privacy statement
        </Body1Strong>
      </PopoverTrigger>
      <PopoverSurface tabIndex={-1}>
        View privacy statement (
        <Link onClick={onClick}>https://privacy.microsoft.com/en-US/data-privacy-notice</Link>)
      </PopoverSurface>
    </Popover>
  );
}

export default PrivacyLink;
